<template>
  <CFooter :fixed="false">
    <div>
      <a href="#" target="_blank">Timóteo</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Todos os direitos reservados.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Elaborado pela</span>
      <a href="https://www.timoteo.mg.gov.br">Secretaria de Desenvolvimento Econômico</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
<style scoped>
.c-footer {
  z-index: 10;
}
</style>
